"use client";
import React from "react";
import { PiTrashBold } from "react-icons/pi";
import { cn } from "~/utils/fontsConfig";

interface TrashButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    iconClassName?: React.ComponentProps<"div">["className"];
}

const TrashButton = ({
    className,
    iconClassName,
    ...props
}: TrashButtonProps) => {
    return (
        <button
            className={cn(
                className,
                "rounded-lg bg-v3-R300 p-2 text-white/80",
                "hover:bg-v3-R400 hover:text-white",
                "transition-colors duration-100",
            )}
            type="button"
            {...props}
        >
            <PiTrashBold className={cn("h-5 w-5", iconClassName)} />
        </button>
    );
};

export default TrashButton;
